/**
 * Area type values
 */
export enum AreaTypeEnum {
	STATE = 'state',
	REGION = 'region',
	CITY = 'city',
	NEIGHBORHOOD = 'neighborhood',
	AIRPORT = 'airport',
	PORT_MARINA = 'port_marina',
	BUS_STATION = 'bus_station',
	TRAIN_STATION = 'train_station',
	REST_AREA = 'rest_area',
	HOTEL = 'hotel',
	RESORT = 'resort',
	LANDMARK = 'landmark',
	POINT_OF_INTEREST = 'point_of_interest',
	OTHER = 'other',
}
